import AddIcon from "@mui/icons-material/Add";

import EditIcon from "@mui/icons-material/Edit";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Link as LinkRRD, Navigate, useNavigate } from "react-router-dom";

import {
  Breadcrumbs,
  Button,
  Card,
  Grid,
  IconButton,
  Link,
  Menu,
  MenuItem,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { border, Stack } from "@mui/system";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import * as XLSX from "xlsx";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useForm } from "react-hook-form";
import { useCSVReader } from "react-papaparse";
import LoadingUI from "../../comman/LoadingUI";
import NoDataFound from "../../comman/NoDataFound";
import SnackBarUI from "../../comman/SnackBarUI";
import Appbar from "../../components/Appbar";
import { Bolt } from "@mui/icons-material";
import Body from "../../layout/Body";
// import AddPartner from "./AddPartner";
import { getAllPartnerAction } from "../../redux/toolkit/partner/allPartner";
import { useDispatch, useSelector } from "react-redux";
import { useStyles } from "../../theme/theme";
// import EditPartner from "./EditPartner";
// import LivePartner from "./LivePartner";
import Chip from "@mui/material/Chip";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment";
import { dateFormatStartFun } from "../../helper/dateConverter";
import { getAllPartnerRevenueAction } from "../../redux/toolkit/partner/allPartnerRevenue";
import AddVideo from "./AddVideo";
import { set } from "lodash";
import { getAllVideoAction } from "../../redux/toolkit/video/allVideo";
import { render } from "@testing-library/react";
import EditVideo from "./EditVideo";
import { getAllPartnerActionNoLimit } from "../../redux/toolkit/partner/getAllPartnerNoLimit";

const breadcrumb = (
  <Stack>
    <Breadcrumbs
      separator={
        <NavigateNextIcon sx={{ color: "#5E6C8A" }} fontSize="small" />
      }
      aria-label="breadcrumb"
    >
      {/* <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/"
      >
        Home
      </Link> */}
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/all-video"
      >
        All Video
      </Link>
    </Breadcrumbs>
    <Typography sx={{ color: "#5E6C8A" }} variant="h4">
      All Video
    </Typography>
  </Stack>
);

const AllVideo = () => {
  const dispatch = useDispatch();
  const [video, setAddVideo] = useState(false);
  const [pageState, setPageState] = useState({ page: 0, pageSize: 25 });
  const [editVideoShow, SetEditVideoShow] = useState(false);
  const [videoId, setVideoId] = useState("");
  const [snack, setSnack] = useState(false);
  const classes = useStyles();
  const navigate = useNavigate();

  let triggerPoints = {
    1: "profiler start",
    2: "profiler complete",
    3: "survey complete",
    4: "survey disqualification",
    5: "Partner Open",
  };

  const partnerDetails = useSelector((state) => state.allPartnerWithoutLimit);

  let getPartnerName = (partnerId) => {
    if (!partnerId) return "";
    let partnerName = partnerDetails?.data?.find((data) => data?._id.toString() === partnerId);
    return partnerName?.name;
  };

console.log("partnerDetails==============================>", partnerDetails)

  const videoData = useSelector((state) => state.allVideo);
  const { loading, data, total, status, message } = videoData;

  const videoColumn = [
    {
      field: "s_no",
      headerName: "S. No.",
      filterable: false,
      flex: 1,
      minWidth: 80,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        const { page, pageSize } = pageState;
        const serialNumber =
          page * pageSize + params?.api?.getRowIndex(params.row._id) + 1;
        return serialNumber;
      },
    },

    {
      field: "triggerpoints",
      headerName: "Triggerpoints",
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <Typography>{triggerPoints[params?.row?.triggerpoints]}</Typography>
        );
      }
    },

    {
      field: "videoLink",
      headerName: "Video Link",
      flex: 1,
      minWidth: 400,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "partnerId",
      headerName: "Partner Id",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <Typography>
            {params?.row?.partnerId ? getPartnerName(params?.row?.partnerId) : "N/A"}
          </Typography>
        );
      },
    },

    {
      field: "timeGap",
      headerName: "Time Gap",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "isActive",
      headerName: "Is Active",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        <Typography>{params?.row?.isActive ? "true" : "false"}</Typography>;
      },
    },

    // {
    //   field: "skipStatus?.isSkip",
    //   headerName: "Is Skip",
    //   flex: 1,
    //   minWidth: 250,
    //   headerClassName: "super-app-theme--header",
    //   renderCell: (params) => {
    //     <Typography>
    //       {params?.row?.skipStatus?.isSkip ? "true" : "false"}
    //     </Typography>;
    //   },
    // },

    // {
    //   field: "skipStatus?.timeGap",
    //   headerName: "IsSkip Time Gap",
    //   flex: 1,
    //   minWidth: 250,
    //   headerClassName: "super-app-theme--header",
    //   renderCell: (params) => {
    //     <Typography>{params?.row?.skipStatus?.timeGap}</Typography>;
    //   },
    // },

    {
      field: "skipStatus.isSkip", // no need for ?. here
      headerName: "Is Skip",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <Typography>
            {params?.row?.skipStatus?.isSkip ? "true" : "false"}
          </Typography>
        );
      },
    },
    {
      field: "skipStatus.timeGap",
      headerName: "IsSkip Time Gap",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return <Typography>{params?.row?.skipStatus?.timeGap}</Typography>;
      },
    },

    {
      field: "dailyLimit",
      headerName: "Daily Limit",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        <Typography>{params?.row?.dailyLimit}</Typography>;
      },
    },

    {
      field: "isGlobal",
      headerName: "Is Global",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        <Typography>{params?.row?.isGlobal ? "true" : "false"}</Typography>;
      },
    },

    {
      field: "dailyTriggerHits",
      headerName: "dailyTriggerHits",
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <Typography>{params?.row?.dailyTriggerHits}</Typography>
        );
      },
    },

    {
      field: "createdAt",
      headerName: "Created At",
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          // <Button variant="contained" disableElevation>
          //   <LinkRRD to={`/single-partner?${params?.row?._id}`}>
          //     <Typography color="primary"> Get Details</Typography>
          //   </LinkRRD>
          moment(params?.row?.createdAt).format("DD-MM-YYYY hh:mm:ss A")
          // </Button>
        );
      },
    },

    {
      field: "edit",
      headerName: "Edit",
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <IconButton
            onClick={() => {
              SetEditVideoShow(true);
              setVideoId(params?.row?._id);
            }}
            color="#071D45"
          >
            <EditIcon color="primary" />
          </IconButton>
        );
      },
    },
  ];

   useEffect(() => {
      dispatch(getAllPartnerActionNoLimit({}));
    }, []);

  useEffect(() => {
    setSnack(true);
    dispatch(
      getAllVideoAction({
        page: pageState.page,
        pageSize: pageState.pageSize,
      })
    );
  }, [pageState.page, pageState.pageSize]);


  return (
    <>
      <Helmet>
        <title> Real Opinion Admin | All Video</title>
      </Helmet>
      <Appbar breadcrumb={breadcrumb} />
      <Body>
        <Stack
          direction="row"
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignContent: "center",
          }}
        >
          {/* <Stack direction="row" spacing={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Start Date"
                value={date?.startDate}
                maxDate={moment()}
                onChange={(newValue) => {
                  setDate({ ...date, startDate: newValue });
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="End Date"
                value={date?.endDate}
                minDate={date?.startDate}
                maxDate={moment()}
                onChange={(newValue) => {
                  setDate({ ...date, endDate: newValue });
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
            {date?.startDate && date?.endDate && (
              <Button variant="contained" onClick={dateWiseUser}>
                find data
              </Button>
            )}
          </Stack> */}

          <Stack direction="row" spacing={0} sx={{ ml: 2 }}>
            <Button
              variant="contained"
              color="btn"
              startIcon={<AddIcon />}
              onClick={() => {
                setAddVideo(true);
              }}
            >
              Create video
            </Button>
          </Stack>
          <Stack direction="row" spacing={0} sx={{ ml: 2 }}>
            <Button
              variant="contained"
              color="btn"
              startIcon={<AddIcon />}
              onClick={() => {
                // setAddVideo(true);
                navigate("/all-video-stat");
              }}
            >
              All Video Stat
            </Button>
          </Stack>
        </Stack>

        <Card sx={{ my: 2 }}>
          <Stack direction={"row"} alignItems="center" sx={{ ml: 1 }}>
            <Typography sx={{ my: 1 }} variant="h6">
              Admin / All Video
            </Typography>
          </Stack>

          <Paper
            sx={{
              bgcolor: "#fff",
              "& .super-app-theme--header": {
                bgcolor: "#071D45",
                color: "#fff",
              },
            }}
            elevation={0}
          >
            <DataGrid
              className={classes.root}
              getRowHeight={() => "auto"}
              sx={{ border: 0 }}
              rows={data}
              autoHeight
              columns={videoColumn}
              getRowId={(row) => row._id}
              disableSelectionOnClick
              experimentalFeatures={{ newEditingApi: true }}
              pagination
              rowsPerPageOptions={[25, 50, 100]}
              disableColumnSelector
              loading={loading ? <LoadingUI /> : false}
              components={{
                NoRowsOverlay: () => <NoDataFound />,
              }}
              rowCount={total}
              paginationModel={setPageState}
              page={pageState.page}
              pageSize={pageState.pageSize}
              paginationMode="server"
              onPageChange={(newPage) => {
                setPageState((old) => ({ ...old, page: newPage }));
              }}
              onPageSizeChange={(newPageSize) =>
                setPageState((old) => ({ ...old, pageSize: newPageSize }))
              }
            />
          </Paper>
        </Card>

        {video && <AddVideo state={video} setState={setAddVideo} />}

        {editVideoShow && (
          <EditVideo
            state={editVideoShow}
            setState={SetEditVideoShow}
            videoId={videoId}
          />
        )}

        <SnackBarUI
          state={snack}
          setState={setSnack}
          status={status}
          message={message}
        />
      </Body>
    </>
  );
};

export default AllVideo;
